/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Gender/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Gender({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content/NewRelation/Add/Content/Details/Gender",
  isInvalid,
  onChange
  
}) {
let gendersGendersValueData = fromData.useDataValue({ viewPath,
context: 'genders',
path: 'genders',
})
let newRelationPersonGenderValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'person.gender',
})
let newRelationPersonGenderIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_relation',
path: 'person.gender',
validate: fromValidate.text,
required: true,
})
let newRelationPersonGenderChangeData = fromData.useDataChange({ viewPath,
context: 'new_relation',
path: 'person.gender',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 maxWidth={280}
 size="medium"
 data="genders.genders"
 from={gendersGendersValueData}
 data="new_relation.person.gender"
 validate="/Data/validate.js text"
 invalid={!newRelationPersonGenderIsValidData}
 required={true}
 value={newRelationPersonGenderValueData}
 onChange={newRelationPersonGenderChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Gender"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}